<template>
  <div v-if="showCard === true" class="up-modal">
    <b-row class="justify-content-center card-row">
      <b-icon-x-square @click="closeModal" />
      <b-col cols="5" class="p-0 justify-content-center d-flex">
        <b-col 
          cols="12"
          class="employee-card text-center"
        >
          <h3 >{{title}}</h3>
          <b-row class="mt-4 justify-content-center">

            <b-col class="text-center">
              <b-button v-if="varian == 'warning'" @click="closeModal" class="btn btn-warning">
                OK
              </b-button>

              <b-button v-if="varian == 'info'" @click="closeModal" class="btn btn-info">
                OK
              </b-button>

              <b-button v-if="varian == 'success'" @click="closeModal" class="btn btn-success">
                OK
              </b-button>
            </b-col>
          </b-row>
        </b-col>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { API_INFO } from "@/constants.js";
import axios from "axios";

export default {

  props: {
    title: String,
    showCard: Boolean,
    varian: String,
  },
  data() {

  },
  mounted() {
    
  },
  methods: {

    closeModal() {
      this.$emit("close-modal")
    }

  },
};
</script>

<style lang="scss" scoped>
.card-row {
  position: relative;
  top: 20vh;
  // max-height: 84vh;
  // overflow: auto; 
}

.employee-card {
  background:rgb(241, 241, 241);
  border-radius: 15px;
  border: 4px solid rgb(151, 159, 173);
  min-height: 270px;
  width: 25vw;
  p {
    font-weight: 700;
    margin-bottom: 10px;
  }
  h3 {
    position: relative;
  }
}

.bi-x-square {
  width: 34px;
  height: 34px;
  position: absolute;
  top: -35%;
  right: 45px;
  cursor: pointer;
  background: antiquewhite;
  z-index: 130;
  &:hover {
    background: rgba(255, 117, 98, 0.822);
  }
}

</style>
